import { Button } from 'antd';
import { useState, useEffect, useRef } from 'react';
import { useStytch } from '@stytch/react';
import InfoDoneIcon from '@assets/info_done.svg';
import classes from './EmailReset.module.css';
import { useAuthContext } from '../../hooks/useAuthContext';

export default function EmailReset() {
  const [msgTip, setMsgTip] = useState(false);
  let { current: timerId } = useRef();
  const data = useAuthContext();
  const { onboarding: { email } = {} } = data || {};
  const stytchClient = useStytch();

  const changePasswordClick = async () => {
    try {
      const loginUrl = `${window.location.origin}/authenticate`;
      const resetPasswordUrl = `${window.location.origin}/reset-password`;
      // https://stytch.com/docs/sdks/javascript-sdk/passwords
      stytchClient.passwords.resetByEmailStart({
        email,
        login_redirect_url: loginUrl,
        reset_password_redirect_url: resetPasswordUrl,
        reset_password_expiration_minutes: 60,
      });
      // 调用stytch发邮件api，发送成功后设置email sent tip
      setMsgTip(true);
    } catch (error) {
      console.log(error);
    }
  };

  // 设置tip msg
  useEffect(() => {
    clearTimeout(timerId);
    if (msgTip) {
      timerId = setTimeout(() => {
        setMsgTip(false);
      }, 3000);
    }
  }, [msgTip, timerId]);

  return (
    <div className={classes.email_resend}>
      <Button onClick={changePasswordClick}>Change password...</Button>
      {msgTip
        && (
          <div className={classes.msg_tip}>
            {/* <div className={classes.done_img}> */}
            <img src={InfoDoneIcon} alt="" />
            {/* </div> */}
            Email resent
          </div>
        )}
    </div>
  );
}
